import useSyncedLocalStorage from "@avinet/adaptive-ui-core/hooks/useSyncedLocalStorage";

export function useBrowserLanguage(): string {
  const lang = (window.navigator.language || "").substr(0, 2).toLowerCase();
  const [userLang] = useSyncedLocalStorage("lang");

  switch (userLang ?? "") {
    case "nb":
    case "no":
    case "nn":
      return "no";
    case "en":
      return "en";
  }

  switch (lang) {
    case "nb":
    case "no":
    case "nn":
      return "no";
    default:
      return "en";
  }
}
